import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { TextField, Modal, Box, FormControl } from "@mui/material";
import MessageSnackbar from "../_layout/elements/snackbar";
import host from "../host";
import { changeAuth } from "../actions/loginAction";
import { useDispatch } from "react-redux";
export default function RenameFile(props) {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  //this below function for openknowledge     popup start//
  const [openeditfile, setOpeneditfile] = React.useState(false);
  const activeeditfile = () => setOpeneditfile(true);
  const handleCloseeditfile = () => setOpeneditfile(false);
  //this below function for openknowledge     popup end//

  const [newName, setNewName] = React.useState(null);
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");

  const onClose = () => {
    setSnackbar(false);
  };


  const renameFile = () => {

    if(newName === null || newName === "" || newName === "null") {
      setSeverity("warning");
      setMessage("Please provide a new name for the file.");
      setSnackbar(true);
      return;
    }

    if (newName.split(".").pop() !== "pdf" && newName.split(".").pop() !== "docx" && newName.split(".").pop() !== "xlsx") {
      setSeverity("warning");
      setMessage("Please provide a valid file extension.");
      setSnackbar(true);
      return;
    }

    fetch(host.chaturl + `/knowledge/file/${props?.fileId}/rename?new_file_name=${newName}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({
        file_id: 1,
        file_name: "dummy.pdf",
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if(data) {
          props.getKnowledge();
          props.handleCloseeditfile();
          setSeverity("success");
          setMessage("File renamed successfully.");
          setSnackbar(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  return (
    <>
            <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />
      <Modal open={props.openeditfile} onClose={props.handleCloseeditfile} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className=" commonpopup  modal-common   popup-w35 ">
        
            <div className="card-item__content   ">
              <div class="card-title">
                <h2>Rename File</h2>
                <span>Please provide a new name for dummy.pdf.</span>
              </div>
              <Link className="close" onClick={props.handleCloseeditfile}>
                X
              </Link>
            </div>
            <div className="modal-body">
            <div className="popup_scroller">
            <div className="popup-knowledge">
              <div className="col-md-12">
                <div className="form-group">
                  <label>File Name</label>
                  <FormControl fullWidth size="small">
                    <TextField id="outlined-multiline-flexible" value={newName} defaultValue={props?.fileName ? props?.fileName : "file"} placeholder="Edit File Name" multiline onChange={(e) => {setNewName(e.target.value)}} />
                  </FormControl>
                </div>
                <div className="col-12 mt-3">
                  <div className="modal-btn">
                    <button type="button" className="btn btn-default w-50">
                      Cancel
                    </button>
                    <button type="button" className="btn btn-primary w-50" onClick={() => {renameFile()}}>
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
